<template>
  <ul class="paypos" v-if="monthlyPrices.withoutInterest && monthlyPrices.withInterest">
    <li class="paypos__item">
        <img alt="" class="paypos__icon" src="/shop/images/paypos-separate-v2.svg">
      <div class="paypos__title items-center justify-center">
        {{ in18['page_split_into_payments'] }}
      </div>
      <div class="paypos__text">{{ in18['page_credit-payments_6m_period'] }} {{ monthlyPrices.withoutInterest.monthlyPrice }} <span>{{ in18['page_credit-payments_6m_no-overpay'] }}</span></div>
      <div class="fw-500 mb-5">
        <a class="link  link--blue" href="#" @click="openDialog($event, '#withoutInterest')"
           :title="in18['link_learn_more_label']">
          {{ in18['link_learn_more_label'] }} &#8250;
        </a>
      </div>
    </li>
    <li class="paypos__item">
        <img alt="" class="paypos__icon" src="/shop/images/paypos-loan-v2.svg">
      <div class="paypos__title">
        {{ in18['page_financial_loan'] }}
      </div>
      <div class="paypos__text">{{ in18['page_credit-payments_24m_period'] }} {{ monthlyPrices.withInterest.monthlyPrice }}</div>
      <div class="fw-500 mb-5">
        <a class="link  link--blue" href="#" @click="openDialog($event, '#withInterest')"
           :title="in18['link_learn_more_label']">
          {{ in18['link_learn_more_label'] }} &#8250;
        </a>
      </div>
    </li>
  </ul><!-- /.paypos -->

  <div v-if="monthlyPrices.withoutInterest && monthlyPrices.withInterest" class="modal" id="withoutInterest"
       tabindex="-1"
       role="dialog" aria-hidden="true">
    <button class="modal__close" type="button" data-close-modal>
      <img src="/shop/images/modal-close.svg" alt="">
    </button>

    <div class="modal__header">
      <h2 class="modal__title">{{ in18['dialog_without-interest_title'] }}</h2>
      <div class="modal__text">{{ in18['dialog_without-interest_header-text'] }}</div>
    </div>

    <hr>

    <div class="modal__content  pt-5">
      <h2 class="modal__title   modal__title--sm">{{ in18['dialog_without-interest_payment-list_title'] }}</h2>

      <ul class="modal__list">
        <li>
          <span>{{ in18['dialog_without-interest_payment-list_item-price'] }}</span>
          <span>{{ monthlyPrices.withoutInterest.itemPrice }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_without-interest_payment-list_monthly-payment'] }}</span>
          <span>{{ monthlyPrices.withoutInterest.monthlyPrice }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_without-interest_payment-list_total'] }}</span>
          <span>{{ monthlyPrices.withoutInterest.priceTotal }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_without-interest_payment-list_overpay'] }}</span>
          <span>{{ monthlyPrices.withoutInterest.overpay }}</span>
        </li>
      </ul>
    </div>

    <hr>

    <div class="modal__text">{{ in18['dialog_without-interest_footer-text'] }}</div>
  </div>

  <div v-if="monthlyPrices.withoutInterest && monthlyPrices.withInterest" class="modal" id="withInterest" tabindex="-1"
       role="dialog" aria-hidden="true">
    <button class="modal__close" type="button" data-close-modal>
      <img src="/shop/images/modal-close.svg" alt="">
    </button>

    <div class="modal__header">
      <h2 class="modal__title">{{ in18['dialog_with-interest_title'] }}</h2>
      <div class="modal__text">{{ in18['dialog_with-interest_header-text'] }}</div>
    </div>

    <hr>

    <div class="modal__content  pt-5">
      <h2 class="modal__title   modal__title--sm">{{ in18['dialog_with-interest_payment-list_title'] }}</h2>

      <ul class="modal__list">
        <li>
          <span>{{ in18['dialog_with-interest_payment-list_item-price'] }}</span>
          <span>{{ monthlyPrices.withInterest.itemPrice }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_with-interest_payment-list_monthly-payment'] }}</span>
          <span>{{ monthlyPrices.withInterest.monthlyPrice }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_with-interest_payment-list_total'] }}</span>
          <span>{{ monthlyPrices.withInterest.priceTotal }}</span>
        </li>
        <li>
          <span>{{ in18['dialog_with-interest_payment-list_overpay'] }}</span>
          <span>{{ monthlyPrices.withInterest.overpay }}</span>
        </li>
      </ul>
    </div>

    <hr>

    <div class="modal__text">{{ in18['dialog_with-interest_footer-text'] }}</div>
  </div>
</template>

<script>
export default {
  name: "ProductCreditPrices",
  props: {
    product: Object,
    in18: {
      type: Object,
    }
  },
  data() {
    return {
      monthlyPrices: []
    };
  },
  created() {
    this.getCreditPrices();
  },
  methods: {
    getCreditPrices() {
      axios.get(`/api/credit/${this.product.id}/monthly-prices`).then(response => {
        this.monthlyPrices = response.data;
      });
    },
    openDialog(event, selector) {
      event.preventDefault();
      $(selector).modal({
        fadeDuration: 100,
        showClose: false,
      });
      $("[data-close-modal]").on("click", function (event) {
        event.preventDefault();
        $.modal.close();
      });
    }
  }
}
</script>